let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e1rTc")).then(() => parcelRequire('gYlnG'));